import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoInvoiceListTotalTtcCell } from './emsp-bo-invoice-list-total-ttc.cell';
import { EmspBoInvoiceListTotalTtcHeader } from './emsp-bo-invoice-list-total-ttc.header';

export const EmspBoInvoiceListTotalTtcColumn: IdentifiedColumnDef<
  EmspUserInvoiceBaseModel,
  EmspUserInvoiceBaseModel['totalTTC']
> = {
  enableSorting: false,
  header: EmspBoInvoiceListTotalTtcHeader,
  cell: EmspBoInvoiceListTotalTtcCell,
};
